// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"privacyPolicy_privacyPolicy__-1+xF"};